"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostScoresResponseV1 = exports.PostScoresBodyV1 = exports.PostScoreBodyV1 = exports.GetScoresResponseV1 = exports.GetScoreResponseDataV1 = exports.GetScoresQueryV1 = exports.DeleteScoreResponseV1 = exports.DeleteScoreQueryV1 = exports.GetScoreResponseV1 = exports.GetScoreQueryV1 = void 0;
const zod_1 = require("zod");
const zod_2 = require("../../../../../utils/zod");
const shared_1 = require("../shared");
const schemas_1 = require("./schemas");
// GET /scores/{scoreId}
exports.GetScoreQueryV1 = shared_1.GetScoreQuery;
exports.GetScoreResponseV1 = schemas_1.APIScoreSchemaV1;
// DELETE /scores/{scoreId}
exports.DeleteScoreQueryV1 = shared_1.DeleteScoreQuery;
exports.DeleteScoreResponseV1 = shared_1.DeleteScoreResponse;
// GET /scores
exports.GetScoresQueryV1 = shared_1.GetScoresQuery;
// GetScoreResponseDataV1 is only used for response of GET /scores list endpoint
exports.GetScoreResponseDataV1 = zod_1.z.intersection(schemas_1.APIScoreSchemaV1, zod_1.z.object({
    trace: zod_1.z.object({
        userId: zod_1.z.string().nullish(),
        tags: zod_1.z.array(zod_1.z.string()).nullish(),
        environment: zod_1.z.string().nullish(),
    }),
}));
exports.GetScoresResponseV1 = zod_1.z.object({
    data: zod_1.z.array(exports.GetScoreResponseDataV1),
    meta: zod_2.paginationMetaResponseZod,
});
// POST /scores
exports.PostScoreBodyV1 = shared_1.PostScoreBody;
exports.PostScoresBodyV1 = shared_1.PostScoresBody;
exports.PostScoresResponseV1 = shared_1.PostScoresResponse;
